import { render, staticRenderFns } from "./EcoPartModal.vue?vue&type=template&id=bd5c481c&name=eco-part-modal&"
import script from "./EcoPartModal.vue?vue&type=script&lang=js&"
export * from "./EcoPartModal.vue?vue&type=script&lang=js&"
import style0 from "./EcoPartModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports